const DISCORD_URL = 'https://discord.gg/5nycCppHET'

export {
    DISCORD_URL
}